import { styled } from '@linaria/react';
import { Divider } from '@daedalus/atlas/Divider';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w15v492c",
  propsAsIs: false
});
export const GridGalleryWrapper = /*#__PURE__*/styled('section')({
  name: "GridGalleryWrapper",
  class: "gvi95x3",
  propsAsIs: false
});
export const MainContentWrapper = /*#__PURE__*/styled('div')({
  name: "MainContentWrapper",
  class: "m5bcpj9",
  propsAsIs: false
});
export const LeftContentWrapper = /*#__PURE__*/styled('div')({
  name: "LeftContentWrapper",
  class: "l1mju3v9",
  propsAsIs: false
});
export const HotelDetailsWrapper = /*#__PURE__*/styled('div')({
  name: "HotelDetailsWrapper",
  class: "h12wniet",
  propsAsIs: false
});
export const ReviewSummaryWrapper = /*#__PURE__*/styled('div')({
  name: "ReviewSummaryWrapper",
  class: "rp3zs3w",
  propsAsIs: false
});
const _exp9 = /*#__PURE__*/() => ({
  scrollTopMargin
}) => `${scrollTopMargin}px`;
export const RightContentWrapper = /*#__PURE__*/styled('div')({
  name: "RightContentWrapper",
  class: "r1tp2fp6",
  propsAsIs: false,
  vars: {
    "r1tp2fp6-0": [_exp9()]
  }
});
const _exp10 = /*#__PURE__*/() => Divider;
export const DividerContainer700 = /*#__PURE__*/styled(_exp10())({
  name: "DividerContainer700",
  class: "d1g5iu4y",
  propsAsIs: true
});
const _exp12 = /*#__PURE__*/() => Divider;
export const DividerContainer = /*#__PURE__*/styled(_exp12())({
  name: "DividerContainer",
  class: "d1i14ids",
  propsAsIs: true
});
export const FooterWrapper = /*#__PURE__*/styled('div')({
  name: "FooterWrapper",
  class: "fnjj8im",
  propsAsIs: false
});
export const RoomsSectionWrapper = /*#__PURE__*/styled('div')({
  name: "RoomsSectionWrapper",
  class: "r7pxlt1",
  propsAsIs: false
});
export const PriceWatchWrapper = /*#__PURE__*/styled('div')({
  name: "PriceWatchWrapper",
  class: "p178v3f",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.tsx");